import * as React from 'react';
const GridRootPropsContext = /*#__PURE__*/React.createContext(undefined);

if (process.env.NODE_ENV !== 'production') {
  GridRootPropsContext.displayName = 'GridRootPropsContext';
}

export { GridRootPropsContext };


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/context/GridRootPropsContext.js
// module id = 1038
// module chunks = 25